/*
Diese Funktion fragt ab, ob wir auf der Seite "products" sind, um lädt dann die Warenbestandsanzeige 
für das Product neu, wenn eine andere Variante über Swatches gewählt wird"
*/
console.log('Custom JS läuft');

$(document).ready(function() {
    if (window.location.href.includes("products")) {
        $('.product-form__input').find('input, button, select').on("click", function(event) {
            console.log('Variante gewechselt - Swatchlist');
            setTimeout(function() {
                $('#reload').load(" #reload");
            }, 25);
        });
    }
});